import 'core-js';

import React from 'react';
import ReactDOM from 'react-dom';
import { Switch, HashRouter as Router, Route } from 'react-router-dom';
import { LocaleProvider } from 'antd';
import enUS from 'antd/lib/locale-provider/en_US';
import 'antd/dist/antd.css';
import './global.css';

import Portal from 'containers/Portal';
import Login from 'containers/Login'; // Email + Password login
import FieldPrograms from 'containers/FieldPrograms';
import TargetXSSO from 'containers/TargetXSSO';
import apiPath from './apiPath';

class Root extends React.Component {
	state = {
		voyages: [],
	};

	getVoyages = async () => {
		try {
			const response = await fetch(`${apiPath}/voyages`);

			if (!response.ok) {
				throw new Error(response.statusText);
			}

			const voyages = await response.json();

			this.setState({ voyages });
		} catch (error) {
			console.error(error);
		}
	};

	componentDidMount() {
		this.getVoyages();
	}

	render() {
		return (
			<Router>
				<Switch>
					<Route path='/fieldprograms/:eventID/:tripCode?' render={(props) => <FieldPrograms voyages={this.state.voyages} {...props} />} />
					<Switch>
						<Route path='/targetxauth/:token/:destination?' component={TargetXSSO} />
						<Route path='/portal' component={Portal} />
						<Route path='/' component={Login} />
					</Switch>
				</Switch>
			</Router>
		);
	}
}

ReactDOM.render(
	<LocaleProvider locale={enUS}>
		<Root />
	</LocaleProvider>,
	document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js